export function appendRoute(route, suffix, { checkParams } = {}) {
  return {
    path: route.path + suffix,
    checkParams: (params) => {
      if (route.checkParams && !route.checkParams(params)) return false;
      if (checkParams && !checkParams(params)) return false;
      return true;
    },
  };
}
